import { TableRow, TableCell, IconButton, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

type TaskRowProp = {
  idTask: number;
  description: string;
  idJira: string;
  handleTaskEdit: Function;
  handleTaskDelete: Function;
  isTaskEditMode: Function;
};

const TaskRow = ({
  idTask,
  description,
  idJira,
  handleTaskEdit,
  handleTaskDelete,
  isTaskEditMode,
}: TaskRowProp) => {
  return (
    <>
      {description && (
        <TableRow className={isTaskEditMode(idTask) ? "edit-mode" : ""}>
          <TableCell>{description}</TableCell>
          <TableCell>{idJira}</TableCell>
          <TableCell align="center">
            <Tooltip title="Edit Task">
              <IconButton
                size="small"
                onClick={() => handleTaskEdit(idTask)}
                sx={{ mx: 0.5 }}
              >
                <EditIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title="Delete Task">
              <IconButton
                size="small"
                onClick={() => handleTaskDelete(idTask)}
                sx={{ mx: 0.5 }}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </TableCell>
        </TableRow>
      )}
    </>
  );
};

export default TaskRow;
